import { useMemo, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { useCampaignSubscription } from '@/hooks/useCampaignSubscription'

const MY_SUBS_SEGMENT = 'my-subscriptions'

const GateBanner = ({ children }) => (
    <div
        className="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:px-4 tw:py-3 tw:text-sm tw:text-white tw:bg-[#0C2243]"
        style={{ borderBottom: '1px solid #3D6FB0' }}
    >
        {children}
    </div>
)

const SubscriptionGate = ({ children }) => {
    const { id: campaignId } = useParams()
    const location = useLocation()
    const [dismissed, setDismissed] = useState(false)

    const onSubscriptionsPage = useMemo(
        () => location.pathname.split('/').includes(MY_SUBS_SEGMENT),
        [location.pathname],
    )

    const { subscriptions, hasActiveLicense } = useCampaignSubscription(campaignId)

    if (onSubscriptionsPage) {
        return children
    }

    if (!campaignId) {
        return children
    }

    if (hasActiveLicense) {
        return children
    }

    const hasLicenseSubscription = subscriptions.some((subscription) => subscription.type === 'LICENSE')
    const hasExpiredLicense = hasLicenseSubscription && !hasActiveLicense

    if (hasExpiredLicense && !dismissed) {
        return (
            <>
                <GateBanner>
                    <span>
                        This campaign subscriptions are expired. Renew your plan to unlock subscription benefits and
                        stay supported.
                    </span>
                    <span className="tw:flex tw:items-center tw:gap-3">
                        <Link
                            to={`/subscriptions?license=${campaignId}`}
                            className="tw:underline tw:text-[#97AFCD] hover:tw:text-white"
                        >
                            Go to subscriptions
                        </Link>
                        <button
                            type="button"
                            onClick={() => setDismissed(true)}
                            className="tw:text-[#97AFCD] hover:tw:text-white tw:text-xs"
                        >
                            Dismiss
                        </button>
                    </span>
                </GateBanner>
                {children}
            </>
        )
    }

    return children
}

export default SubscriptionGate
